var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLevelUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_level-up_svg__icon_level-up",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_level-up_svg__cls-2{fill:none;stroke:#575757;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_level-up_svg__Rectangle_2908",
    "data-name": "Rectangle 2908",
    fill: "none",
    d: "M0 0h40v40H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_level-up_svg__streamline-icon-arrow-double-up_140x140",
    "data-name": "streamline-icon-arrow-double-up@140x140",
    transform: "translate(-9.417 3.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_level-up_svg__Path_2272",
    "data-name": "Path 2272",
    className: "icon_level-up_svg__cls-2",
    d: "M29.417 11.439l-7.745 4.928a.819.819 0 01-1.255-.691V10.7a1.636 1.636 0 01.764-1.38l7.358-4.685a1.636 1.636 0 011.756 0l7.364 4.691a1.636 1.636 0 01.758 1.375v4.976a.819.819 0 01-1.258.691z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon_level-up_svg__Path_2273",
    "data-name": "Path 2273",
    className: "icon_level-up_svg__cls-2",
    d: "M29.417 77.9l-7.745 4.928a.819.819 0 01-1.255-.691v-4.971a1.636 1.636 0 01.764-1.381l7.363-4.685a1.636 1.636 0 011.756 0l7.364 4.691a1.636 1.636 0 01.753 1.376v4.975a.819.819 0 01-1.258.691z",
    transform: "translate(0 -54.035)"
  }))));
}
export default SvgIconLevelUp;